// src/pages/index.tsx
import Head from "next/head";
import LandingContent from "@/components/organisms/Landing/LandingContent";
import LandingHero from "@/components/organisms/Landing/sections/LandingHero";
import { HeroCharacter } from "@/images"; // Import the image source

// Helper function to get the base path if it's a StaticImageData object
const getImagePath = (src: string | {
  src: string;
}): string => {
  return typeof src === "string" ? src : src.src;
};
const Home = () => {
  const heroImageSrc = getImagePath(HeroCharacter);
  const imageQuality = 80;

  // Construct imageSrcSet based on common widths and sizes attribute
  // Match widths used by Next.js default deviceSizes
  const widths = [640, 750, 828, 1080, 1200, 1920];
  const imageSrcSet = widths.map(w => `/_next/image?url=${encodeURIComponent(heroImageSrc)}&w=${w}&q=${imageQuality} ${w}w`).join(", ");

  // Match the sizes attribute used in LandingHero
  const imageSizes = "(max-width: 767px) calc(100vw - 2rem), 33vw";
  return <>
            <Head data-sentry-element="Head" data-sentry-source-file="index.tsx">
                {/* Preload the LCP image */}
                <link rel="preload" as="image" href={`/_next/image?url=${encodeURIComponent(heroImageSrc)}&w=1920&q=${imageQuality}`} imageSrcSet={imageSrcSet} imageSizes={imageSizes} fetchPriority="high" />
            </Head>
            <div className="overflow-x-hidden">
                {/* Critical Hero Section - Rendered immediately */}
                <LandingHero data-sentry-element="LandingHero" data-sentry-source-file="index.tsx" />
                <LandingContent data-sentry-element="LandingContent" data-sentry-source-file="index.tsx" />
            </div>
        </>;
};
export default Home;